"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adminDrawContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const models_1 = require("./models");
const dbJsonModels_1 = require("@daymade/common-lib/dbJsonModels");
const utils_1 = require("../../utils");
const c = (0, core_1.initContract)();
exports.adminDrawContract = c.router({
    getDrawsByGroup: {
        method: 'GET',
        path: '/draw/group/:group',
        pathParams: zod_1.z.object({
            group: zod_1.z.string(),
        }),
        query: zod_1.z.object({
            includeCompleted: zod_1.z.optional(utils_1.booleanParamSchema),
            limit: zod_1.z.optional(zod_1.z.coerce.number()),
            offset: zod_1.z.optional(zod_1.z.coerce.number()),
        }),
        responses: {
            200: zod_1.z.object({
                draws: zod_1.z.array(zod_1.z.object({
                    draw: models_1.ZDrawSelectAdmin,
                    draw_schedule: models_1.ZDrawScheduleSelectAdmin,
                    draw_type: models_1.ZDrawTypeSelect,
                })),
            }),
        },
    },
    getDraw: {
        method: 'GET',
        path: '/draw/:id',
        pathParams: zod_1.z.object({
            id: zod_1.z.coerce.number(),
        }),
        responses: {
            200: zod_1.z.object({
                draw: zod_1.z.object({
                    draw: models_1.ZDrawSelectAdmin,
                    draw_schedule: models_1.ZDrawScheduleSelectAdmin,
                    draw_type: models_1.ZDrawTypeSelect,
                }),
            }),
        },
    },
    verificationComplete: {
        method: 'POST',
        path: '/draw/:draw_id/verification-complete',
        pathParams: zod_1.z.object({
            draw_id: zod_1.z.coerce.number(),
        }),
        body: zod_1.z.object({}),
        responses: {
            200: zod_1.z.object({
                draw: zod_1.z.object({
                    draw: models_1.ZDrawSelectAdmin,
                    draw_schedule: models_1.ZDrawScheduleSelectAdmin,
                    draw_type: models_1.ZDrawTypeSelect,
                }),
            }),
        },
    },
    setDrawResults: {
        method: 'POST',
        path: '/draw/:draw_id/results',
        pathParams: zod_1.z.object({
            draw_id: zod_1.z.coerce.number(),
        }),
        body: zod_1.z.object({
            results: dbJsonModels_1.ZDrawTypeFullResult,
        }),
        responses: {
            200: zod_1.z.object({
                draw: zod_1.z.object({
                    draw: models_1.ZDrawSelectAdmin,
                    draw_schedule: models_1.ZDrawScheduleSelectAdmin,
                    draw_type: models_1.ZDrawTypeSelect,
                }),
            }),
        },
    },
    autoGenerateResults: {
        method: 'POST',
        path: '/draw/:draw_id/auto-generate-results',
        pathParams: zod_1.z.object({
            draw_id: zod_1.z.coerce.number(),
        }),
        body: zod_1.z.object({}),
        responses: {
            200: zod_1.z.object({
                draw: zod_1.z.object({
                    draw: models_1.ZDrawSelectAdmin,
                    draw_schedule: models_1.ZDrawScheduleSelectAdmin,
                    draw_type: models_1.ZDrawTypeSelect,
                }),
            }),
        },
    },
    awardAndNotifyPrizes: {
        method: 'POST',
        path: '/draw/:draw_id/award-and-notify-prizes',
        pathParams: zod_1.z.object({
            draw_id: zod_1.z.coerce.number(),
        }),
        body: zod_1.z.object({}),
        responses: {
            200: zod_1.z.object({
                queued: zod_1.z.boolean(),
                draw: zod_1.z.object({
                    draw: models_1.ZDrawSelectAdmin,
                    draw_schedule: models_1.ZDrawScheduleSelectAdmin,
                    draw_type: models_1.ZDrawTypeSelect,
                }),
            }),
        },
    },
    simulateWinners: {
        method: 'POST',
        path: '/draw/:draw_id/simulate-winners',
        pathParams: zod_1.z.object({
            draw_id: zod_1.z.coerce.number(),
        }),
        body: zod_1.z.object({}),
        responses: {
            200: zod_1.z.object({
                winners: zod_1.z.record(zod_1.z.string(), zod_1.z.object({ code: zod_1.z.string(), total: zod_1.z.string() })),
            }),
        },
    },
    getDrawSchedules: {
        method: 'GET',
        path: '/draw-schedules',
        responses: {
            200: zod_1.z.object({
                drawSchedules: models_1.ZDrawScheduleSelect.extend({
                    drawType: models_1.ZDrawTypeSelect,
                    drawTypePlans: models_1.ZDrawTypePlanSelect.array(),
                    nextDraw: models_1.ZDrawSelectAdmin,
                }).array(),
            }),
        },
    },
    getBoostedEntriesForDraw: {
        method: 'GET',
        path: '/draw/:draw_id/boosted-entries',
        pathParams: zod_1.z.object({
            draw_id: zod_1.z.coerce.number(),
        }),
        responses: {
            200: zod_1.z.object({
                boostedEntries: zod_1.z.array(zod_1.z.object({
                    entry_id: zod_1.z.string(),
                    purchase_date: zod_1.z.date(),
                    numbers: zod_1.z.string(),
                })),
            }),
        },
    },
}, {
    pathPrefix: '/admin',
    strictStatusCodes: true,
    commonResponses: {
        401: c.type(),
        403: c.type(),
    },
});
//# sourceMappingURL=draw.admin.contract.js.map